'use strict';

import 'angular';

import {addClassDirective} from './utils';

const MODULE_NAME = 'brg.style.bootstrap3';

var app = angular.module(MODULE_NAME, []);
app.directive('ngMessages', addClassDirective('help-block'));
app.directive('brgRestFieldLinked', addClassDirective('form-group'));
app.directive('brgRestQueryPrevious', addClassDirective('btn btn-default'));
app.directive('brgRestQueryNext', addClassDirective('btn btn-default'));
app.directive('label', addClassDirective('', 'control-label'));

['input', 'textarea', 'select'].forEach(function(name) {
	app.directive(name, addClassDirective('', 'form-control'));
});

export default MODULE_NAME;
